module.exports = __webpack_public_path__ + "img/menu.9dcbf51b.png";